export enum EReportCode {
  TicketsMotivoFechamentoMensal = 1,
  TicketsPorQuadroUsuarioMensal = 2,
  TicketsPorQuadroUsuarioDiario = 3,
  TicketsPorInteracaoAutomacaoEnvio = 4,
  TicketsPorFalhaInteracaoAutomacaoEnvio = 5,
  QuantidadeDeMensagensCRMPorEstabMensal = 6,
  QuantidadesDeAssinaturasDigitaisPorEstabMensal = 7,
  QuantidadeDeRequisicoesBarramentoDadosPorEstab = 8,
  AreasAtendimentoMenuMaisAcessados = 9,
}
